<template>
   <div class="thank-you-header">
      <div class="container">
         <div class="tick-container">
            <div class="tick"></div>
         </div>

         <div v-if="alreadySwitched">
            <h1>Processing Switch</h1>
            <p>
               Your switch has now been completed and is being processed by <b>{{ supplierName }}</b>.
               <br />Please contact the supplier if you have any questions related to your new tariff
            </p>
         </div>

         <div v-else>
            <h1>Thank you</h1>
            <p>
               Your switching application has been successfully submitted.
               <br /> <b>{{ supplierName }}</b> will be in touch with you.
            </p>
         </div>

         <small>Reference Number</small>
         <p class="_margin-top-0 _margin-bottom-0">{{ referenceNumber }}</p>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'ThankYouHeader',
   props: {
      supplierName: String,
      referenceNumber: String,
      alreadySwitched: {
         type: Boolean,
         default: false
      }
   }
};
</script>

<style lang="scss">
.thank-you-header {
   background-color: $metis-vitality-green;
   padding: 40px 15px 30px 15px;
   margin: 0 0 30px 0;
   color: $metis-cloud-grey;

   h1 {
      font-size: 40px;
      margin: 0;
      line-height: 1.2;
      color: $metis-cloud-grey;
      font-weight: 800;
   }

   p {
      font-size: 20px;
      color: $metis-cloud-grey;
      line-height: 1.3;
   }

   small {
      color: $metis-cloud-grey;
   }

   .tick-container {
      position: relative;
      display: block;
      margin-bottom: 20px;
      width: 100px;
      height: 100px;
      background-color: darken($metis-vitality-green, 8%);
      border-radius: 50%;

      .tick {
         position: absolute;
         left: 0;
         top: 0;
         right: 0;
         bottom: 0;
         margin: auto;
         width: 32px;
         height: 24px;
         background: url('../../../assets/tick.png') no-repeat;
         background-size: contain;
         background-position: 100% 0;
      }
   }
}
</style>
